export const isFormDataChanged = (data) => data.anyTouched
  && Object.entries(data.fields)
    .filter(([, field]) => field.touched)
    .some(([name]) => data.initial[name] !== data.values[name]);
